// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.streeteasy.RentalManagerUserStreetEasyWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { LinkStreetEasyUserRequestDto } from '../..';

export const RentalManagerUserStreetEasyWebApiHandler_linkUser_Path = '/api/web/v1/users/streetEasy/linkUser';

/**
 * Link the session's StreetEasy user to the account and refresh its listing permissions
 */
export const RentalManagerUserStreetEasyWebApiHandler_linkUser = (
  postData: LinkStreetEasyUserRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, LinkStreetEasyUserRequestDto, void>(
    {
      endpoint: RentalManagerUserStreetEasyWebApiHandler_linkUser_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
